export default __webpack_public_path__ + "static/media/banner-3.a903a730.png";